<div class="tableInfo">
  <h2 class="titleTable">Por unidad</h2>
  <div class="select">
    <mat-form-field>
      <mat-label>Unidad</mat-label>
      <mat-select (selectionChange)="getDataUnit()" [(ngModel)]="unitSelected">
        <mat-option *ngFor="let unit of units" [value]="unit._id">{{
          unit.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-table *ngIf="res" [dataSource]="dataSource" class="mat-elevation-z8">
    <div *ngFor="let labels of res.labelTable">
      <ng-container [matColumnDef]="labels">
        <mat-header-cell *matHeaderCellDef>{{ labels }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element[labels] }}
        </mat-cell>
      </ng-container>
    </div>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
<div class="graphics">
  <h1 *ngIf="res" class="title">Gerencia {{ res.labelTable[1] }}</h1>

  <div class="divChart" id="contentByUnitReportResume">
    <canvas id="ByUnitReportResume" width="30"></canvas>
  </div>
</div>
